import * as React from 'react';
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Checkbox,
  Box,
  Autocomplete,
  TextField
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Student Name',
  'Session',
  'Asana',
  'Date',
];

export default function MultipleSelectCheckmarks({
  selectedFilters,
  handleFilterChange,
  filterValues,
  handleFilterValueChange,
  handleDateChange,
  filterOptions
}) {
  return (
    <>
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
      <FormControl sx={{ width: 200 }}>
        <InputLabel id="filter-select-label">Select Filters</InputLabel>
        <Select
          labelId="filter-select-label"
          id="filter-select"
          multiple
          value={selectedFilters}
          onChange={handleFilterChange}
          input={<OutlinedInput label="Select Filters" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps} >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={selectedFilters.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedFilters.map((filterName) => (
        filterName === 'Date' ? (
          <LocalizationProvider dateAdapter={AdapterDayjs} key={filterName}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <DatePicker
                label="Start Date"
                value={filterValues['Date'][0]}
                onChange={(newValue) => handleDateChange(0, newValue)}
                slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
              />
              <DatePicker
                label="End Date"
                value={filterValues['Date'][1]}
                onChange={(newValue) => handleDateChange(1, newValue)}
                slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
              />
            </Box>
          </LocalizationProvider>
        ) : (
          <Autocomplete
            key={filterName}
            options={filterOptions[filterName] || []}
            value={filterValues[filterName] || ''}
            onChange={(event, newValue) => handleFilterValueChange(filterName, newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label={filterName}
                variant="outlined"
                size="small"
                InputLabelProps={{ sx: { top: '10%', transform: 'translateY(-50%), translateX(25%)',   } }}
              />
            )}
            sx={{ width: 200 }}
          />
        )
      ))}
    </Box>   
    </>
  );
}
